import React from 'react';
import PropTypes from 'prop-types';

import TransactionDetails from './TransactionDetails';
import { TRANSACTION_DETAILS_MODAL } from '../../../constants/modals';
import withModal from '../../global/modal/withModal';

const propTypes = {
  actionProps: PropTypes.shape({
    transactionItem: PropTypes.object,
  }),
};

const TransactionDetailsModal = ({ actionProps = {}, ...props }) => {
  const { transactionItem } = actionProps ?? {};

  return <TransactionDetails transactionItem={transactionItem} {...props} />;
};

TransactionDetailsModal.propTypes = propTypes;

export default withModal(TransactionDetailsModal, {
  name: TRANSACTION_DETAILS_MODAL,
  size: 'lg',
  contentLabel: 'Transaction Item Details',
});
